// Seconds as m:ss for the MFA countdowns (SSN/TIN wait, setup expiry). Third copy extracted (global Rule 2).
export const clock = (seconds) => `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, "0")}`;
